import { plainRetrieve, safeRetrieve } from './safeStoring';
import { makeToast } from './makeToast';
import { DEFAULT_COOBBLIGATO } from '../data/coobbligato';


export const callExtractor = (filesS3Keys, ocrMethod=false) => {
    return new Promise((resolve, reject) => {

        const apiUrl = process.env.REACT_APP_API_URL || '';
        const apiKey = safeRetrieve('APIKEY_v2');
        const apiName = ocrMethod ? 'v1/extract_pdf_ocr_llm' : 'v1/extract_pdf';
        fetch(`${apiUrl}/api/extractor/${apiName}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                api_key: apiKey,
                files_s3_keys: filesS3Keys
            }),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((errorData) => {
                    console.error(`Error in ${apiName} response: ${response.status}`, errorData);
                    makeToast(`C'è stato un errore nel processo di estrazione, per favore controlla che il documento caricato sia conforme ai requisiti. Se necessario, contatta l'amministratore di sistema.`, 'warning');
                    resolve([]);  // resolve with an empty array on error
                });
            }
            return response.json();  // Proceed to parse JSON if the response is OK
        })
        .then((data) => {
            resolve(data.body);  // the extraction result
        })
        .catch((error) => {
            console.error('Request failed:', error);
            makeToast('Si è verificato un errore di rete. Per favore riprova più tardi.', 'warning');
            resolve([]);  // resolve with an empty array on error
        });
    
    });
};




export const callCreateTele24 = (extractionResult) => {

    const cfContribuente = extractionResult['contribuente']['codice_fiscale'] || '';
    const paymentDate = extractionResult['payment_date'] || '';

    const infoFornitore = plainRetrieve('infoFornitore');
    const infoVersanteAll = plainRetrieve('infoVersante');
    const infoContoIbanAll = plainRetrieve('infoContoIban');

    // complete payload with default values
    const payload = { ...extractionResult }
    payload['fornitore'] = infoFornitore;
    payload['versante'] = infoVersanteAll[cfContribuente] || {};
    payload['coobbligato'] = DEFAULT_COOBBLIGATO;
    payload['conto_iban'] = {
        "codice_fiscale": cfContribuente,
        "iban": infoContoIbanAll[cfContribuente]
    };
    console.log(payload);

    // // remove temporary fields
    // delete infoFornitore.persona_fisica.pf_codice_fiscale;
    // delete infoFornitore.partita_iva.piva_codice_fiscale;
    // // remove info of persona fisica if partita iva is selected and viceversa
    // const savedFornitore = plainRetrieve('savedFornitore');
    // if (savedFornitore === 'persona-fisica') {
    //     infoFornitore.partita_iva = {};
    // } else if (savedFornitore === 'partita-iva') {
    //     infoFornitore.persona_fisica = {};
    // }

    // let infoVersanteSelected = {};
    // try {
    //     infoVersanteSelected = infoVersanteAll.filter(item => item.contribuente === cfContribuente)[0];
    // } catch (error) {
    //     makeToast(`Non è stato dichiarato un versante associato al seguente contribuente: ${cfContribuente}`, 'warning');
    //     console.log(`Non è stato dichiarato un versante associato al seguente contribuente: ${cfContribuente}`);
    //     return;
    // }
    // const infoVersante = Object.fromEntries(
    //     Object.entries(infoVersanteSelected).filter(([key]) => key !== 'contribuente' && key !== 'iban' && key !== 'nome_versante')
    // );

    // let payload = { ...extractionResult }
    // try {
    //     // complete payload with default values
    //     payload['fornitore'] = infoFornitore;
    //     payload['versante'] = infoVersante;
    //     payload['coobbligato'] = DEFAULT_COOBBLIGATO;
    //     payload['conto_iban'] = { 'iban': infoVersanteSelected.iban };
    //     payload['conto_iban']['codice_fiscale'] = cfContribuente;
    // } catch (error) {
    //     makeToast(`C'è stato un errore. Controlla che siano stati dichiarati tutti i campi del versante associato al seguente contribuente: ${cfContribuente}`, 'warning');
    //     console.log(`C'è stato un errore, Controlla che siano stati dichiarati tutti i campi del versante associato al seguente contribuente: ${cfContribuente}`);
    //     return {}
    // }

    
    const apiKey = safeRetrieve('APIKEY_v2');
    const apiUrl = process.env.REACT_APP_API_URL || '';
    return fetch(`${apiUrl}/api/tele24/v1/create_telematic_file`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            api_key: apiKey,
            data: payload
        }),
    })
    .then((response) => {
        if (!response.ok) {
            return response.json().then((errorData) => {
                console.error(`Error in create_telematic_file response: ${response.status}`, errorData);
                // makeToast(`C'è stato un errore nel processo di estrazione, per favore controlla che il documento caricato sia conforme ai requisiti. Se necessario, contatta l'amministratore di sistema.`, 'warning');
                return {};  // return an empty dict on error
            });
        }
        return response.json();  // Proceed to parse JSON if the response is OK
    })
    .then((data) => {
        if (data && data.body) {
            return {
                'cfContribuente': cfContribuente,
                'paymentDate': paymentDate,
                's3Key': data.body,
                'extractionResult': payload
            }
        } else {
            console.warn('Unexpected response structure:', data);
            return {};  // return an empty dict on error
        }
    })
    .catch((error) => {
        console.error('Request failed:', error);
        makeToast('Si è verificato un errore di rete. Per favore riprova più tardi.', 'warning');
        return {};  // return an empty dict on error
    });
};
